export default function parseAspectRatio(aspectRatio = '') {
  if (Array.isArray(aspectRatio)) {
    aspectRatio = aspectRatio.join(':');
  }
  const [width, height] = aspectRatio
    .split(':')
    .map((val) => parseInt(val, 10));
  return width / height;
}
